import { useCallback, useState } from 'react'

import packageInfo from '../../../package.json'

const RELEASE_NOTES_SEEN_KEY = 'capo_release_notes_seen'

const minorVersion = (version: string | null) =>
  version?.split('.').slice(0, 2).join('.')

const readSeenVersion = (): string | null => {
  try {
    return window.localStorage.getItem(RELEASE_NOTES_SEEN_KEY)
  } catch {
    return packageInfo.version
  }
}

export const useReleaseNotes = () => {
  const [seenVersion, setSeenVersion] = useState(readSeenVersion)

  const markSeen = useCallback(() => {
    try {
      window.localStorage.setItem(RELEASE_NOTES_SEEN_KEY, packageInfo.version)
    } catch {
      // badge verdwijnt voor deze sessie ook als opslaan niet lukt
    }

    setSeenVersion(packageInfo.version)
  }, [])

  return {
    unseen: minorVersion(seenVersion) !== minorVersion(packageInfo.version),
    markSeen,
  }
}
